_ = require 'underscore'
Auth = require 'db/auth'
Controller = require 'controller'
l = require 'lib/localize'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')()
trackUe = require 'debug/trackUe'
Storage = require 'lib/storage'

BoardCopy = {
  'education': {
    description: "This board allows you to brainstorm ideas, compile research, work on drafts, and collaborate with others to create an A+ project."
    name: 'Student Research Board'
  }
  'project-management': {
    description: "The goal of this board is to help you manage any project. It allows you to keep track of the progress of your tasks and smaller-scale projects within a larger project"
    name: 'Project Manager Board'
  }
  'wedding': {
    description: "This board is the master list of wedding-related tasks, laid out in order of what to do next as you countdown to your big day. Customize anything here to plan your dream event."
    name: 'Wedding Planning Board'
  }
  'business': {
    description: "Give people a high-level overview of what's happening across your company on an ongoing basis, as well as the ability to dive into the details."
    name: 'Company Overview Board'
  }
  'creative-arts': {
    description: "Organize your podcast from ideas to finished episodes, and keep track of all the production steps. Then, make sure it gets the distribution plan it’s due!"
    name: 'Podcast Editorial Workflow Board'
  }
  'engineering-it': {
    description: "Use this board for a 100% sticky note-less production workflow to track the entire process, even as it evolves."
    name: 'Production Workflow Board'
  }
  'event-planning': {
    description: "Stay on top of every little detail when it comes to organizing an amazing event, from ticket sales to contracts, seating charts, and RSVPs."
    name: 'Event Planning Board'
  }
  'home': {
    description: "Getting totally organized at home can seem like an impossible feat. Here is an easy way to organize and keep track of weekly household chores and tasks."
    name: 'board to help with household chores'
  }
  'marketing': {
    description: "Create more transparency within your marketing team and the company. Get a high-level view of team goals, current projects, and what’s launching next."
    name: 'Marketing Overview Board'
  }
  'personal-goals': {
    description: "Set, plan, and achieve your life's greatest goals with this limitless board. Outline your life’s goals, adding photos and links for inspiration, to put yourself on the fast track towards success."
    name: 'Life Goals Board'
  }
  'productivity': {
    description: "Use this board to keep track of your ideas, goals, projects, and tasks. With all your important work in one place, no key details will slip through the cracks!"
    name: 'Ultimate To-Do Board'
  }
  'sales-crm': {
    description: "Create a pipeline for managing incoming leads or requests that is adaptable to your team’s needs for any type of contact or customer relationship management."
    name: 'Sales & CRM Pipeline Board'
  }
  'support': {
    description: "Resolve bugs as they arise to keep your code running smoothly with a clear and simple way to organize incoming bug reports from your team in one place."
    name: 'Bug Tracking Board'
  }
  'travel': {
    description: "Planning a vacation should be a fun adventure! Let Trello help manage everything from your itinerary to your budget, so you can focus on mapping out uncharted territory."
    name: 'board to help you plan your vacation'
  }
}

class InspirationBoardExplanation extends React.Component
  displayName: 'InspirationBoardExplanation'

  onKeep: ->
    trackUe('board', 'dismiss', 'inspiration popover explanation', '', '', 'by clicking keep button in popover')
    PopOver.hide()
    return

  onStartFromScratch: =>
    trackUe('board', 'dismiss', 'inspiration popover explanation', '', '', 'by clicking start from scratch button in popover')
    PopOver.hide()

    initialData =
      name: l(['untitled board'])

    requestData = _.extend({
      creationMethod: 'assisted'
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      defaultLists: false
    }, initialData)

    return Auth.me().boardList.create initialData, {
      requestData: requestData
      success: (board) =>

        # This fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # On this new board, we will render a popover, guiding the user to name
        # their first list.
        # - shouldShowInspirationScratchGuide will ensure it renders,
        # - inspirationBoardOptionValue will give it the correct copy,
        # - previousBoardId will allow the user to quickly return to this board
        Controller.displayBoard({
          idBoard: board.id
          openListComposer: true
          openCardComposerInFirstList: false
          shouldShowInspirationScratchGuide: true
          inspirationBoardOptionValue: @props.boardOption
          previousBoardId: @props.boardId
        }).done()

        return
      error: =>
        Controller.displayErrorPage()
    }

  render: t.renderable ->
    boardName =

    t.div '.inspiration-board-explanation-wrapper', =>
      t.h3 =>
        t.div =>
          t.text "Here's an example "
          t.text BoardCopy[@props.boardOption].name
          t.text '.'
        t.div ->
          t.text 'Now make it yours!'
      t.p '.inspiration-board-explanation-copy', =>
        t.text BoardCopy[@props.boardOption].description
      t.div '.inspiration-board-explanation-actions', =>
        t.button '.primary', onClick: @onKeep, ->
          t.text 'Keep This'
        t.button '.button-link', onClick: @onStartFromScratch, ->
          t.text 'Start From Scratch'

module.exports = InspirationBoardExplanation



// WEBPACK FOOTER //
// ./app/scripts/views/board/inspiration-board-explanation-component.coffee